export const breakpoints = {
  xsmall: 375,
  small: 780,
  medium: 1090,
  large: 1800,
}
